import CSS from 'csstype';

interface IFonts {
  General: IGeneralFonts;
  Predefined: IPredefinedFonts;
}

interface IBoldFonts {
  '14px22px': CSS.Properties;
  '12px17px': CSS.Properties;
  '22px33px': CSS.Properties;
}

interface IPredefinedFonts {
  semiBold14px22px: CSS.Properties;
  light14px22px: CSS.Properties;
  Bold: IBoldFonts;
  regular14px16px: CSS.Properties;
}

interface IFontWeights {
  semiBold: number;
  bold: number;
  light: number;
  regular: number;
}

interface IGeneralFonts {
  fontFamily: string;
  FontWeights: IFontWeights;
}

const generalFonts: IGeneralFonts = {
  fontFamily: 'Overpass',
  FontWeights: {
    light: 300,
    regular: 400,
    semiBold: 600,
    bold: 700
  }
};

export const predefinedFonts: IPredefinedFonts = {
  semiBold14px22px: {
    fontFamily: generalFonts.fontFamily,
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: generalFonts.FontWeights.semiBold,
    letterSpacing: '0px'
  },
  light14px22px: {
    fontFamily: generalFonts.fontFamily,
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: generalFonts.FontWeights.light,
    letterSpacing: '0px'
  },
  Bold: {
    '14px22px': {
      fontFamily: generalFonts.fontFamily,
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: generalFonts.FontWeights.bold,
      letterSpacing: '0px'
    },
    '12px17px': {
      fontFamily: generalFonts.fontFamily,
      fontSize: '12px',
      lineHeight: '17px',
      fontWeight: generalFonts.FontWeights.bold,
      letterSpacing: '0px'
    },
    '22px33px': {
      fontFamily: generalFonts.fontFamily,
      fontSize: '22px',
      lineHeight: '33px',
      fontWeight: generalFonts.FontWeights.bold,
      letterSpacing: '0px'
    }
  },
  regular14px16px: {
    fontFamily: generalFonts.fontFamily,
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: generalFonts.FontWeights.regular,
    letterSpacing: '0px'
  }
};

export const fonts: IFonts = {
  General: generalFonts,
  Predefined: predefinedFonts
};
